import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {Response} from '@angular/http';
import {Service} from '../../../domain/model/common/service.class';
import {SectionService} from '../../../domain/model/common/section-service.class';
import {Model} from '../../../domain/model/common/model.class';
import {BasicInfo} from './basic-info.model';
import {ContactInfo} from './contact-info.model';
import {IdentificationInfoProjection, IdentificationInfoProjectionType} from './identification-info.model';
import {Profile} from '../../../domain/model/profile/profile.model';

const CURRENT_USER_PATH = 'currentUser';

/**
 * Created by Rodrigo Quesada on 04/12/16.
 */
@Injectable()
export class PersonalDetailsSectionService extends SectionService {

    constructor(svcm: Service.InjectedMembers) {
        super(svcm, 'personalDetails');
    }

    currentUserBasicInfo(): Observable<BasicInfo | undefined> {
        return this.getForCurrentUser(BasicInfo);
    }

    updateCurrentUserBasicInfo(info: BasicInfo): Observable<Response> {
        return this.updateForCurrentUser(info);
    }

    currentUserContactInfo(): Observable<ContactInfo | undefined> {
        return this.getForCurrentUser(ContactInfo);
    }

    updateCurrentUserContactInfo(info: ContactInfo): Observable<Response> {
        return this.updateForCurrentUser(info);
    }

    currentUserIdentificationInfo(): Observable<IdentificationInfoProjectionType | undefined> {
        return this.get(Profile, CURRENT_USER_PATH, IdentificationInfoProjection);
    }

    updateCurrentUserIdentificationInfo(info: IdentificationInfoProjectionType): Observable<Response> {
        return this.update(info, CURRENT_USER_PATH, IdentificationInfoProjection);
    }

    private getForCurrentUser<T extends Model<T>>(type: Model.Type<T>): Observable<T> {
        return this.get(type, CURRENT_USER_PATH);
    }

    private updateForCurrentUser(model: Model<any>): Observable<Response> {
        return this.update(model, CURRENT_USER_PATH);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/pages/personal-details/model/personal-details-section.service.ts